import { useCallback } from 'react';
import { useSelector } from 'react-redux';

// Hooks
import { useChatBot } from './use-chat-bot';

// Types
import { AppType } from 'Shared/types/App.type';

// Actions
export const useApp = () => {
  const app = useSelector((state: { app: AppType }) => state.app);
  const { id: appId, piAppUrl } = app;

  const isZoom = app.id === 'zoom';
  const isWeb = app.id === 'web';
  const isChrome = app.id === 'chrome';
  const isTeamsEmbeddedTab = app.id === 'teams_embedded_tab';
  const intercomAppId = app.intercomAppId;
  const intercomContactSalesEventName = app.intercomContactSalesEventName;
  const intercomTOEPerformanceReviewsEventName = app.intercomTOEPerformanceReviewsEventName;

  const { triggerChatBot } = useChatBot();
  const handleContactSales = useCallback(() => {
    triggerChatBot({ eventName: app.intercomContactSalesEventName });
  }, []);

  return {
    app,
    appId,
    isZoom,
    isWeb,
    isChrome,
    isTeamsEmbeddedTab,
    handleContactSales,
    piAppUrl,
    intercomAppId,
    intercomContactSalesEventName,
    intercomTOEPerformanceReviewsEventName,
  };
};
